import { render, staticRenderFns } from "./ModalPromotionInfo.vue?vue&type=template&id=d9beef58&scoped=true"
import script from "./ModalPromotionInfo.vue?vue&type=script&lang=js"
export * from "./ModalPromotionInfo.vue?vue&type=script&lang=js"
import style0 from "./ModalPromotionInfo.vue?vue&type=style&index=0&id=d9beef58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9beef58",
  null
  
)

export default component.exports